import { createAction } from 'Utility/Redux';

enum Types {
    UPDATE_TIMER = 'updateTimer',
}

export interface ITimerActionPayload {
    timer: string;
    time?: Date;
}

export const TimerActions = {
    updateTimer: createAction(
        Types.UPDATE_TIMER,
        resolve => (timer: ITimerActionPayload) =>
            resolve<ITimerActionPayload>(timer)
    ),
};
